import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

import { LoanService } from '../../shared-component/service/loan/loan.service';
import { UtilService } from '../../util/util.service';

@Component({
  selector: 'app-bitly',
  templateUrl: './bitly.component.html',
  styleUrls: ['./bitly.component.scss']
})
export class BitlyComponent implements OnInit {

  public showPaymentScheduleList: boolean = false;

  private tokenId: string;
  public loanDetail: any = {};
  public paymentSchedule: any = [];
  public downPaymentSchedule: any = {};
  public advanceAmount: any = {};
  public link: any;
  public PDFLink: any = 'https://s3.amazonaws.com/techfino.static/insurance/care/SCHEME+DOCUMENT+-+Techfino+Capital+Private+Limited.pdf';
  public PDFLink599: any = 'https://s3.amazonaws.com/techfino.static/insurance/care/SCHEME+DOCUMENT(599)+-+Techfino+Capital+Private+Limited.pdf';
  public PDFLink999: any = 'https://s3.amazonaws.com/techfino.static/insurance/care/SCHEME+DOCUMENT(999)+-+Techfino+Capital+Private+Limited.pdf';
  public PDFLink1299: any = 'https://s3.amazonaws.com/techfino.static/insurance/care/SCHEME+DOCUMENT(1299)+-+Techfino+Capital+Private+Limited.pdf';
  public form: FormGroup;

  public structuredEmiAmt: number = 0;
  public structuredEmiCount: number = 0;
  public structuredEmiList: any = [];
  public totalInterestAmount: any = 0;
  public totalPrincipalAmount: any = 0;
  public irrRate: any = 0;
  public crd: any = {};
  public insuranceAutoChecked = false;
  public externalCodePolicyAutoChecked = false;
  public allowCrossSell = false;

  constructor(
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private loanService: LoanService,
    private utilService: UtilService
  ) { }

  ngOnInit() {
    this.utilService.getCurrentPosition(this);

    this.form = this.fb.group({
      insuranceAmountAgreement: [false, Validators.compose([Validators.required])],
      addInsuranceAmountToEMI: [false, Validators.compose([Validators.required])],
      externalPolicyCheck: [true, Validators.compose([Validators.required])],
      acceptKFS: [false, Validators.compose([Validators.required])]
    });

    this.getLoanDetails();
    this.getAdvanceAmount();
     if (this.loanDetail.insuranceAmount == 599) {
      this.link = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.google.com/viewer?url=${encodeURIComponent(this.PDFLink599)}&embedded=true`);
    }
     else if (this.loanDetail.insuranceAmount == 999) {
      this.link = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.google.com/viewer?url=${encodeURIComponent(this.PDFLink999)}&embedded=true`);
    }
     else if (this.loanDetail.insuranceAmount == 1299) {
      this.link = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.google.com/viewer?url=${encodeURIComponent(this.PDFLink1299)}&embedded=true`);
    }
    else {
      this.link = this.sanitizer.bypassSecurityTrustResourceUrl(`https://docs.google.com/viewer?url=${encodeURIComponent(this.PDFLink)}&embedded=true`);
    }
  }

  get insuranceAmountAgreement() {
    return this.form.get('insuranceAmountAgreement');
  }

  get addInsuranceAmountToEMI() {
    return this.form.get('addInsuranceAmountToEMI');
  }

  get externalPolicyCheck() {
    return this.form.get('externalPolicyCheck');
  }

  get acceptKFS() {
    return this.form.get('acceptKFS');
  }

  checkFormValidity() {
    if (this.loanDetail.Organization.id == 2) {
      return (this.form.get('acceptKFS') && this.form.get('acceptKFS').value);
    }
    else {
      return true;
    }
  }

  getLoanDetails(flag = false) {
    this.activeRoute.data.subscribe((res: any) => {
      this.loanDetail = res.loanDetail;
      this.tokenId = this.loanDetail.token;
      try{
        this.allowCrossSell = res.loanDetail.Branch.Partner.PartnerLoanSetting.allowCrossSell || false;
      } catch(e){
        this.allowCrossSell = false;
      }
      
      if(this.allowCrossSell == false){
        this.insuranceAutoChecked = false;
      }

      if (this.allowCrossSell && flag == false && this.loanDetail.Organization.id == 1) {
        this.insuranceAutoChecked = true;
        this.changeEvent({ target: { checked: true } });
      }
      if (res.loanDetail.structuredEmis) {
        this.structuredEmiList = JSON.parse(res.loanDetail.structuredEmis);
        if (this.structuredEmiList.length) {
          //this.reCalculateSchedule();
        }
      }
      this.externalCodePolicyAutoChecked = true;
      this.getPaymentSchedule();
    });
  }

  getAdvanceAmount() {
    this.loanService.paymentSchedule(this.tokenId, this.form.get('insuranceAmountAgreement').value).subscribe((res: any) => {
      this.advanceAmount = res.data;
    });
  }

  changeEvent(event) {
    if (this.loanDetail.Organization.id != 1) {
      return false;
    }

    this.insuranceAutoChecked = false;
    if (event.target.checked) {
      this.insuranceAmountAgreement.setValue(true);
      this.addInsuranceAmountToEMI.setValue(true);
      this.insuranceAutoChecked = true;
    } else {
      this.insuranceAmountAgreement.setValue(false);
      this.addInsuranceAmountToEMI.setValue(false);
    }
    this.getPaymentSchedule(false);
    this.getLoanDetails(true);
  }

  changeKFSEvent(event) {
    if (event.target.checked) { 
      this.acceptKFS.setValue(true)
    } else {
      this.acceptKFS.setValue(false)
    };
  }

  openTOCPopup(content: any) {
    this.modalService.open(content, { backdrop: 'static', centered: true, size: 'lg' });
  }

  openNotReadyPopUp(content: any) {
    this.modalService.open(content, { backdrop: 'static', centered: true });
  }

  openCancelApplicationPopup(content: any) {
    this.modalService.open(content, { backdrop: 'static', centered: true });
  }

  getPaymentSchedule(openPopup = true) {
    this.loanService.paymentSchedule(this.tokenId, this.form.get('insuranceAmountAgreement').value).subscribe((res: any) => {
      this.downPaymentSchedule = res.data;
      let aLoanAmount = res.data.balance;
      this.advanceAmount = res.data;
      this.paymentSchedule = [{
        balance: Math.round(res.data.balance)
      }, ...res.data.schedule.map((o, i) => {
        return {
          serialNo: ++i,
          paymentDate: o.date,
          interest: Math.round(o.interest),
          balance: Math.round(o.remainingBalance),
          paymentDue: Math.round(o.interest + o.principal),
          principal: Math.round(o.principal),
          totalPaid: (Math.round(aLoanAmount - o.remainingBalance) * 100 / aLoanAmount).toFixed(2)
        };
      })];
      if (openPopup) {
        //this.generateChart();
        this.calculateIRR();
        this.showPaymentScheduleList = true;
      }
    });
  }

  async goNext() {
    if (!this.crd.status) {
      return false;
    }
    let details = this.crd.data; //await this.utilService.getDeviceDetails();
    let data = {
      applyInsurance: this.form.get('insuranceAmountAgreement').value,
      addInsuranceAmountToEMI: this.form.get('addInsuranceAmountToEMI').value,
      externalPolicyCheck: this.form.get('externalPolicyCheck').value,
      acceptKFS: this.form.get('acceptKFS').value,
      organizationId: this.loanDetail.Organization.id,
      ...details
    };

    this.loanService.loanInit(this.tokenId, data).subscribe(() => {
      this.router.navigateByUrl(`/loan/process/${this.tokenId}/termsOfService`, { replaceUrl: true }).then();
    });
  }

  cancelApplication() {
    this.loanService.putCancelApplication(this.tokenId).subscribe(() => {
      this.router.navigateByUrl(`/loan/process/${this.tokenId}/status`, { replaceUrl: true }).then();
    });
  }

  generateChart() {
    let tmp = [...this.paymentSchedule];
    tmp.shift();

    let data: any = tmp.reduce((o, i) => {
      o["interest"].push(Math.round(i.interest));
      o["principal"].push(Math.round(i.principal));
      o["outstanding"].push((100 - i.totalPaid).toFixed(2));
      o["emidate"].push(moment(i.paymentDate, 'YYYY-MM-DD').format('MM-YYYY'));
      o["amount"] += i.principal;
      o["totalinterest"] += i.interest;
      return o;
    }, { "amount": 0, "totalinterest": 0, "emidate": [], "interest": [], "principal": [], "outstanding": [] });

    data["advanceToPartner"] = (this.downPaymentSchedule.advance.partner.amount) || 0;
    data["advanceToTCPL"] = (this.downPaymentSchedule.advance.system.amount) || 0;

    setTimeout(
      function () {
        window["c3"].generate({
          bindto: "#breakup-chart",
          data: {
            columns: [
              ['AdvanceToTCPL', data["advanceToTCPL"]],
              ['AdvanceToPartner', data["advanceToPartner"]],
              ['Principal', data["amount"]],
              ['Interest', data["totalinterest"]]
            ],
            type: 'pie'
          },
          legend: {
            position: 'right'
          },
          gauge: {
            label: {
              format: function (value, ratio) {
                return value.toFixed(2) + "%";
              }
            },
          },
          color: {
            pattern: ['#F97600', '#FF0000', '#60B044', '#F6C600'] // the three color levels for the percentage values.
          },
          size: {
            height: 200
          }
        });
      }, 500);
  }

  calculateIRR() {
    let CArray = [-this.paymentSchedule[0].balance];
    this.paymentSchedule.reduce((a, item) => {
      CArray.push(item.paymentDue);
    });

    let guest = 0.001;
    let inc = 0.000001;
    let NPV = 0;
    do {
      guest += inc;
      NPV = 0;
      for (var j = 0; j < CArray.length; j++) {
        NPV += CArray[j] / Math.pow((1 + guest), j);
      }
    } while (NPV > 0);

    this.irrRate = ((guest * 100) * 12);

    return this.irrRate;
  }

  downloadSchedule() {
    this.delayDownload(document.getElementById("emiSchedule").innerHTML);
  }

  tableToExcel() {
    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    return function (name, data) {
      var ctx = { worksheet: name || 'Worksheet', table: data }
      window.location.href = uri + base64(format(template, ctx))
    }
  };

  delayDownload(dataTable) {
    let oThat = this;
    setTimeout(function () {
      let dynFun: any = oThat.tableToExcel();
      dynFun(oThat.loanDetail.applicationNumber + "-EMI-Schedule", dataTable.replace(/₹/ig, ""));
    }, 1000);
  }

  openNewWindowKFSDocument(content) {
    this.loanService.getBcKFS(this.tokenId).subscribe((res: any) => {
      let base64Data = res.data.kfs; 
      this.link = this.sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64,${base64Data}`); 
      this.modalService.open(content, { backdrop: 'static', centered: true, size: 'lg' });
    });
  }

}
